import { LoadingSpinnerComponent } from 'components/common/Loading/LoadingSpinnerComponent';
import { createTourOptions } from 'actions/onboarding/onboardingTourFactory';
import {
  fixedElementCssWorkaround,
  customizeIntroJsStyle
} from './OnboardingTour.style';
import OnboardingTourService from './OnboardingTourService';
import PropTypes from 'prop-types';
import React from 'react';

// Components
/**
 * Usage:
 *  This is a one-use element at the root of the application.
 *  If you have more than one in your DOM, you're using it wrong.
 *
 * Tour usage outlined in README.
 *
 * @see OnboardingTourService
 */
class OnboardingTourComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPageLoading: false
    };
    this.tourService = new OnboardingTourService((isPageLoading) =>
      this.setState({ isPageLoading })
    );
  }

  componentWillUnmount() {
    this.tourService.cleanUp();
  }

  componentDidMount() {
    this.tourService.setTranslate(this.context.t).setProps(this.props);
  }

  componentDidUpdate(prevProps) {
    const { isTourActive, tourQueue } = this.props;
    const { t } = this.context;

    if (isTourActive && prevProps.tourQueue !== tourQueue && tourQueue.length) {
      const tourOptions = createTourOptions({
        tourName: tourQueue[0],
        t,
        props: this.props
      });
      this.tourService
        .setTranslate(this.context.t)
        .setProps(this.props)
        .startTour(tourOptions);
    }
  }

  render() {
    const { navbarColor } = this.props;
    return (
      <React.Fragment>
        <style type="text/css">
          {fixedElementCssWorkaround}
          {customizeIntroJsStyle}
        </style>
        <LoadingSpinnerComponent
          color={navbarColor}
          isLoading={this.state.isPageLoading}
        />
      </React.Fragment>
    );
  }
}

OnboardingTourComponent.propTypes = {
  isTourActive: PropTypes.bool.isRequired,
  tourQueue: PropTypes.array.isRequired,
  clientCode: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  navbarColor: PropTypes.string.isRequired
};

OnboardingTourComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default OnboardingTourComponent;



// WEBPACK FOOTER //
// ./src/components/common/OnboardingTour/OnboardingTourComponent.js